export default null;throw new Error("Unable to resolve \"../pkg\" from npm:lightningcss@1.22.1/node/index.js");